import { TaskStatus } from "fond/types/task";

type WorkflowVersion = {
  /** The UUID of this Version */
  ID: string;

  /** The Project this Version belongs to. */
  Project: { ID: string };
};

export type Workflow = {
  /** The UUID of this Workflow */
  ID: string;

  /** The Version this workflow is attached to. */
  Version: WorkflowVersion;

  /** The status of this workflow. */
  Status: TaskStatus;

  /** The time the workflow was cancelled, if any. */
  CancelTime: string | null;
};

/**
 * Union type for all valid custom workflow keys used throughout the application.
 */
export type WorkflowKey =
  | "nbn_cost_to_serve"
  | "nbn_cost_to_serve_iteration"
  | "nbn_idd_lite_generate_design"
  | "nbn_idd_lite_clean_data"
  | "isg_extract"
  | "isg_data_prep"
  | "isg_solve"
  | "irby_small_batch_generate_design"
  | "irby_base_data"
  | "irby_design_generation"
  | "collaboration_cost_to_serve"
  | "collaboration_cost_to_serve_iteration"
  | "planner_extended_data_prep"
  | "planner_extended_service_area";

/**
 * Organized workflow keys by category for better discoverability and maintainability.
 * Use these constants instead of hardcoded strings throughout the application.
 */
export const WORKFLOW_KEYS = {
  NBN_COST_TO_SERVE: {
    ROOT: "nbn_cost_to_serve" as const,
    ITERATION: "nbn_cost_to_serve_iteration" as const,
  },
  NBN_IDD_LITE: {
    GENERATE_DESIGN: "nbn_idd_lite_generate_design" as const,
    CLEAN_DATA: "nbn_idd_lite_clean_data" as const,
  },
  IRBY: {
    SMALL_BATCH_GENERATE: "irby_small_batch_generate_design" as const,
    BASE_DATA: "irby_base_data" as const,
    DESIGN_GENERATION: "irby_design_generation" as const,
  },
  COLLABORATION_CTS: {
    ROOT: "collaboration_cost_to_serve" as const,
    ITERATION: "collaboration_cost_to_serve_iteration" as const,
  },
  PLANNER_EXTENDED: {
    DATA_PREP: "planner_extended_data_prep" as const,
    SERVICE_AREA: "planner_extended_service_area" as const,
  },

  ISG: {
    EXTRACT: "isg_extract" as const,
    DATA_PREP: "isg_data_prep" as const,
    SOLVE: "isg_solve" as const,
  },
} as const;
